<template>
	<div>
		<navbar :title="title" />
		<van-form @submit="onSubmit">
			<van-field
				v-model="event_text"
				name="选择事件"
				label="选择事件"
				placeholder="选择选择事件"
				readonly
				@click="popup.event = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择选择事件' }]"
			/>
			<van-field
				v-model="client_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.client = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="order_text"
				name="关联订单"
				label="关联订单"
				placeholder="选择关联订单"
				readonly
				@click="popup.order = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联订单' }]"
			/>
			<van-field
				v-model="form.dispatch_name"
				name="流程名称"
				label="流程名称"
				placeholder="选择流程名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择流程名称' }]"
			/>
			<van-field
				v-model="form.initiate_date"
				name="预计完成日期"
				label="预计完成日期"
				placeholder="选择预计完成日期"
				readonly
				@click="popup.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择预计完成日期' }]"
			/>
			<van-field
				v-model="form.dispatch_remark"
				rows="3"
				autosize
				label="派单说明"
				type="textarea"
				placeholder="请输入派单说明"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="6" accept="all" icon="upgrade" />
				</template>
			</van-field>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="organization" icon="description" to="/dispatch">我组织的</van-tabbar-item>
			<van-tabbar-item name="initiate" icon="logistics" to="/dispatch/initiate">我发起的</van-tabbar-item>
			<van-tabbar-item name="carriedOut" icon="upgrade" to="/dispatch/carriedOut">我执行的</van-tabbar-item>
			<van-tabbar-item name="add" icon="add-o" to="/dispatch/add">新增派单</van-tabbar-item>
		</van-tabbar>

		<van-popup v-model="popup.event" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="eventList.list"
				@onload="onloadEvent"
				@check="checkEvent"
				:loading="eventList.loading"
				:finished="eventList.finished"
				value-key="event_name"
			></popup-select>
		</van-popup>
		<van-calendar v-model="popup.calendar" @confirm="confirmCalendar" />
		<van-popup v-model="popup.client" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onloadClient"
				@check="checkClient"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
		<van-popup v-model="popup.order" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="orderList.list"
				@onload="onloadOrder"
				@check="checkOrder"
				:loading="orderList.loading"
				:finished="orderList.finished"
				value-key="order_name"
			></popup-select>
		</van-popup>
	</div>
</template>

<script>
import popupselect from "@/components/select/index";
import navbar from "@/components/navBar/index";
import { getNowFormatDate } from "@/utils/tool";
import { Toast } from "vant";
import { post } from "@/api/dispatch";
// import { uploadFile } from "@/api/file";
import axios from "axios";
import { getToken } from "@/utils/auth";

export default {
	name: "customer",
	components: {
		navbar,
		"popup-select": popupselect
	},
	data() {
		return {
			title: "新增派单",
			activeName: "add",
			form: {
				event_id: "",
				client_id: "",
				order_id: "",
				initiate_date: "",
				dispatch_remark: "",
				uploader: []
			},
			event_text: "",
			client_text: "",
			order_text: "",
			popup: {
				event: false,
				client: false,
				order: false,
				calendar: false
			},
			eventList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25
			},
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20000
			},
			orderList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20000
			}
		};
	},
	methods: {
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("event_id", this.form.event_id);
			formData.append("client_id", this.form.client_id);
			formData.append("order_id", this.form.order_id);
			formData.append("dispatch_name", this.form.dispatch_name);
			formData.append("initiate_date", this.form.initiate_date);
			formData.append("dispatch_remark", this.form.dispatch_remark);
			formData.append("requestType", "event_initiate");
			formData.append("token", getToken());

			const config = {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			};
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then(function (res) {
					if (res.status === 200) {
						Toast.fail("新增派单成功!");
						that.clearForm();
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				});
		},
		onloadEvent(search) {
			if (search != undefined) {
				this.eventList.page = 1;
			}
			post({
				requestType: "event_list_data",
				page: this.eventList.page,
				limit: this.eventList.limit,
				event_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.eventList.finished = true;
					}
					if (this.eventList.page != 1) {
						this.eventList.list = this.eventList.list.concat(
							res.obj.rows
						);
					} else {
						this.eventList.list = res.obj.rows;
					}

					this.eventList.page += 1;
					this.eventList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.eventList.loading = false;
					this.eventList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloadClient(search) {
			if (search != undefined) {
				this.clientList.page = 1;
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloadOrder(search) {
			if (search != undefined) {
				this.orderList.page = 1;
			}
			post({
				requestType: "order_list_data",
				page: this.orderList.page,
				limit: this.orderList.limit,
				order_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.orderList.finished = true;
					}
					if (this.orderList.page != 1) {
						this.orderList.list = this.orderList.list.concat(
							res.obj.rows
						);
					} else {
						this.orderList.list = res.obj.rows;
					}

					this.orderList.page += 1;
					this.orderList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.orderList.loading = false;
					this.orderList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		checkClient(value) {
			this.popup.client = false;
			this.client_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		checkOrder(value) {
			this.popup.order = false;
			this.order_text = value.order_name;
			this.form.order_id = value.order_id;
		},
		checkEvent(value) {
			this.popup.event = false;
			this.event_text = value.event_name;
			this.form.event_id = value.event_id;
		},
		confirmCalendar(value) {
			this.form.initiate_date = getNowFormatDate(value);
			this.popup.calendar = false;
		},
		clearForm() {
			for (var key in this.form) {
				if (key == "uploader") {
					this.form[key] = [];
				} else if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.order_text = "";
			this.client_text = "";
			this.event_text = "";
		}
	}
};
</script>

<style scoped>
.van-icon-photograph:before {
	content: "\F0D2";
}
</style>